import { Option } from 'shared/components/Select/models/Option';

export const NEUTRAL_OPTION_VALUE = 0;

export const NEUTRAL_OPTION = new Option(NEUTRAL_OPTION_VALUE, 'Неважно');
